module.exports = __webpack_public_path__ + "img/ch16_10_洗零件.241db78a.jpg";